import Select, { components } from "react-select";
import { options } from "./options";

const SelectSexo = (props) => {
  const Component = (props) => (
    <div style={{ border: `2px dotted #5243AA`, borderRadius: "5px", background: "#f2fcff" }}>
      <components.Group {...props} />
    </div>
  );

  return (
    <Select
      isDisabled={props.disabled}
      value={props.value}
      name={props.name}
      id={props.id}
      placeholder={props.placeholder}
      components={{ Component }}
      options={options}
      className={props.className}
      onChange={props.onChange}
      isSearchable={props.isSearchable}
      isClearable={props.isClearable}
    />
  )
};

export default SelectSexo;